import React, { useEffect, useMemo, useState } from "react";
import { IoIosArrowDown,IoIosArrowUp } from "react-icons/io";
import { LuEye } from "react-icons/lu";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from "recharts";
const API_BASE = process.env.REACT_APP_NAV_API || "http://localhost:8080";
function getPresetRange(type) {
  const now = new Date();

  const toYmd = (d) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  let start = new Date(now);
  let end = new Date(now);

  switch (type) {
    case "last_month":
      start.setMonth(start.getMonth() - 1);
      break;

    case "quarter":
      start.setMonth(start.getMonth() - 3);
      break;

    case "6_months":
      start.setMonth(start.getMonth() - 6);
      break;

    case "1_year":
      start.setFullYear(start.getFullYear() - 1);
      break;

    default:
      return getPreviousWeekRange();
  }

  return {
    startDate: toYmd(start),
    endDate: toYmd(end),
  };
}
function getPreviousWeekRange() {
  const now = new Date();
  const istNow = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );

  const day = istNow.getDay();
  const mondayOffset = day === 0 ? -6 : 1 - day;

  const thisMonday = new Date(istNow);
  thisMonday.setDate(istNow.getDate() + mondayOffset);
  thisMonday.setHours(0, 0, 0, 0);

  const prevMonday = new Date(thisMonday);
  prevMonday.setDate(thisMonday.getDate() - 7);

  const prevFriday = new Date(prevMonday);
  prevFriday.setDate(prevMonday.getDate() + 4);

  const toYmd = (d) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  return {
    startDate: toYmd(prevMonday),
    endDate: toYmd(prevFriday),
  };
}

function formatDisplayDate(dateStr) {
  if (!dateStr) return "";

  const [yyyy, mm, dd] = dateStr.split("-");
  return `${dd}-${mm}-${yyyy}`;
}
function fmtScore(v) {
  const num = Number(v);
  if (Number.isNaN(num)) return "-";
  return num.toFixed(2);
}

function formatXAxisLabel(value) {
  if (!value) return "";

  const words = value.split(" ");
  const maxWordsPerLine = 2;

  const lines = [];
  for (let i = 0; i < words.length; i += maxWordsPerLine) {
    lines.push(words.slice(i, i + maxWordsPerLine).join(" "));
  }

  return lines;
}
// function getScoreClass(rank) {
//   if (rank <= 3) {
//     return {
//       rowBg: "#eaf7ef",
//       dot: "#18a957",
//       badgeBg: "#f3a11a",
//       score: "#18a957",
//     };
//   }
//   return {
//     rowBg: "#f8f1e4",
//     dot: "#f3a11a",
//     badgeBg: "#d9dde5",
//     score: "#f3a11a",
//   };
// }

function getScoreClass(rank) {
  if (rank <= 3) {
    return {
      rowBg: "#fdfffe",
      dot: "#18a957",
      badgeBg: "#f3a11a",
      score: "#18a957",
    };
  }
  return {
    rowBg: "#fbfbfb",
    dot: "#f3a11a",
    badgeBg: "#d9dde5",
    score: "#f3a11a",
  };
}
function getScoreStyle(score) {
  const num = Number(score);

  if (isNaN(num)) return {};

  if (num >= -19) {
    return {
      background: "#54d994", // light green
      color: "#000",
      padding: "6px 2px",
      borderRadius: 4,
      textAlign: "center",
      fontWeight: 700,
    };
  }

  return {
    background: "#ef5454", // light red
    color: "#000",
    padding: "6px 2px",
    borderRadius: 4,
    textAlign: "center",
    fontWeight: 700,
  };
}

function getRangeStyle() {
  return {
    background: "#dae4ea", // light blue
    color: "#0369a1",
    padding: "4px 6px",
    borderRadius: 4,
    fontWeight: 600,
  };
}

const sectionTitleStyle = {
  fontSize: 16,
  fontWeight: 700,
  color: "#0f172a",
  marginBottom: 10,
};

const tableWrapStyle = {
  overflowX: "auto",
  border: "1px solid #e5e7eb",
  borderRadius: 2,
  background: "#fff",
};

const thStyle = {
  padding: "8px 10px",
  textAlign: "left",
  fontSize: 12,
  color: "#f3f4f5",
  borderBottom: "1px solid #e5e7eb",
  whiteSpace: "nowrap",
  background: "#274aab",
  fontWeight: 700,
};

const tdStyle = {
  padding: "8px 10px",
  borderBottom: "1px solid #f1f5f9",
  fontSize: 12,
  color: "#0f172a",
  verticalAlign: "top",
};

export default function TopDepartmentScore({ activeDoerEmail }) {
  const defaultRange = useMemo(() => getPreviousWeekRange(), []);

  const [startDate, setStartDate] = useState(defaultRange.startDate);
  const [endDate, setEndDate] = useState(defaultRange.endDate);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState({});
  const [err, setErr] = useState("");

  const [showAll, setShowAll] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [detailsMap, setDetailsMap] = useState({});
  const [showPerformance, setShowPerformance] = useState(false);
  const [preset, setPreset] = useState("previous_week");

async function loadSummary() {
  setLoading(true);
  setErr("");
  setSelectedDepartment("");
  try {
    const url =
      `${API_BASE}/topdepartment/summary` +
      `?startDate=${encodeURIComponent(startDate)}` +
      `&endDate=${encodeURIComponent(endDate)}` +
      `&limit=5`;

    const res = await fetch(url, {
  method: "GET",
  credentials: "include",
  headers: {
    "Content-Type": "application/json",
  },
});
    const json = await res.json();

    if (!res.ok || !json.ok) {
      throw new Error(json.error || "Failed to load top departments");
    }

    setRows(Array.isArray(json.data) ? json.data : []);
    setShowAll(false);
  } catch (e) {
    setErr(e.message || "Failed to load data");
    setRows([]);
  } finally {
    setLoading(false);
  }
}

async function loadAllDepartments() {
  setLoading(true);
  setErr("");
  try {
    const url =
      `${API_BASE}/topdepartment/all` +
      `?startDate=${encodeURIComponent(startDate)}` +
      `&endDate=${encodeURIComponent(endDate)}`;

    const res = await fetch(url, {
  method: "GET",
  credentials: "include",
  headers: {
    "Content-Type": "application/json",
  },
});
    const json = await res.json();

    if (!res.ok || !json.ok) {
      throw new Error(json.error || "Failed to load all departments");
    }

    setRows(Array.isArray(json.data) ? json.data : []);
    setShowAll(true);
  } catch (e) {
    setErr(e.message || "Failed to load all departments");
  } finally {
    setLoading(false);
  }
}

  async function loadDetails(departmentName) {
    setSelectedDepartment(departmentName);

    if (detailsMap[departmentName]) {
      return;
    }

    setDetailsLoading((prev) => ({ ...prev, [departmentName]: true }));
    try {
      const url =
        `${API_BASE}/topdepartment/details` +
        `?startDate=${encodeURIComponent(startDate)}` +
        `&endDate=${encodeURIComponent(endDate)}` +
        `&departmentName=${encodeURIComponent(departmentName)}`;

const res = await fetch(url, {
  method: "GET",
  credentials: "include",
  headers: {
    "Content-Type": "application/json",
  },
});
      const json = await res.json();

      if (!res.ok || !json.ok) {
        throw new Error(json.error || "Failed to load details");
      }

      setDetailsMap((prev) => ({
        ...prev,
        [departmentName]: json.data || null,
      }));
    } catch (e) {
      alert(e.message || "Failed to load details");
      setSelectedDepartment("");
    } finally {
      setDetailsLoading((prev) => ({ ...prev, [departmentName]: false }));
    }
  }


  function handlePresetChange(value) {
  setPreset(value);

  const range = getPresetRange(value);
  setStartDate(range.startDate);
  setEndDate(range.endDate);

  setShowAll(false);
  setSelectedDepartment("");
  setDetailsMap({});
}
useEffect(() => {
  loadSummary();
}, [startDate, endDate]);

  const visibleRows = showAll ? rows : rows.slice(0, 5);
  const modalDetails = selectedDepartment ? detailsMap[selectedDepartment] : null;
  const modalLoading = selectedDepartment
    ? !!detailsLoading[selectedDepartment]
    : false;

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
          marginBottom: 18,
          // margin: 6,
        }}
      >
        <div
          style={{
            width: "100%",
            // maxWidth: "40%",
            minWidth: 420,
            background: "#fff",
            border: "1px solid #e8edf5",
            borderRadius: 10,
            boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
            padding: 16,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 8,
              flexWrap: "wrap",
              marginBottom: 15,
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 15,
                  lineHeight: 1,
                  marginBottom: 6,
                }}
              >
                🏆{" "}
                <span
                  style={{
                    fontWeight: 700,
                    color: "#0f172a",
                  }}
                >
                  Department Performance Ranking
                </span>
              </div>

              <div
                style={{
                  padding: "2px 6px",
                  fontSize: 9,
                  color: "#475569",
                }}
              >
               Selected Range: <strong>
  {formatDisplayDate(startDate)} to {formatDisplayDate(endDate)}
</strong>
              </div>
            </div>



          </div>

<div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>

  {/* Dropdown */}
  <select
    value={preset}
    onChange={(e) => handlePresetChange(e.target.value)}
    style={{
      padding: "4px 7px",
      borderRadius: 6,
      border: "1px solid #d1d5db",
      fontSize: 11,
      cursor: "pointer",
    }}
  >
    <option value="previous_week">Previous Week</option>
    <option value="last_month">Last Month</option>
    <option value="quarter">Quarter (3 Months)</option>
    <option value="6_months">6 Months</option>
    <option value="1_year">1 Year</option>
  </select>

  {/* Start Date */}
  <input
    type="date"
    value={startDate}
    onChange={(e) => {
      setPreset("custom");
      setStartDate(e.target.value);
    }}
    style={{
      padding: "4px 2px",
      borderRadius: 6,
      border: "1px solid #d1d5db",
      fontSize: 10,
    }}
  />

  {/* End Date */}
  <input
    type="date"
    value={endDate}
    onChange={(e) => {
      setPreset("custom");
      setEndDate(e.target.value);
    }}
    style={{
      padding: "4px 2px",
      borderRadius: 6,
      border: "1px solid #d1d5db",
      fontSize: 10,
    }}
  />

</div>


<div
  style={{
    height: 230,              // you can adjust: 240 / 260 / 300
    overflowY: "auto",
    paddingRight: 4,
    marginTop: 6,
  }}
>
  {loading && (
    <div
      style={{
        padding: 24,
        textAlign: "center",
        color: "#64748b",
        fontWeight: 600,
      }}
    >
      Loading top departments...
    </div>
  )}

  {!loading && err && (
    <div
      style={{
        padding: 14,
        background: "#fff1f2",
        border: "1px solid #fecdd3",
        borderRadius: 12,
        color: "#be123c",
        marginBottom: 12,
      }}
    >
      {err}
    </div>
  )}

  {!loading && !err && visibleRows.length === 0 && (
    <div
      style={{
        padding: 24,
        textAlign: "center",
        color: "#64748b",
        fontWeight: 600,
        marginTop: 30,
      }}
    >
      No department data found for selected range.
    </div>
  )}

  {!loading &&
    !err &&
    visibleRows.map((row) => {
      const rank = Number(row.Department_Rank || 0);
      const ui = getScoreClass(rank);
      const departmentName = row.Department_Name_In_HRMantra;
      const rowLoading = !!detailsLoading[departmentName];
      // console.log(row);

      return (
        <div key={departmentName} style={{ marginBottom: 12 }}>
          <div
            style={{
              background: ui.rowBg,
              borderRadius: 6,
              padding: "2px 8px",
              border: "1px solid #edf2f7",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  minWidth: 0,
                }}
              >
                <div
                  style={{
                    width: 25,
                    height: 25,
                    minWidth: 25,
                    borderRadius: "50%",
                    background: ui.badgeBg,
                    color: rank <= 3 ? "#fff" : "#475569",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 700,
                    fontSize: 11,
                  }}
                >
                  {rank}
                </div>

                <div style={{ minWidth: 0 }}>
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: 11,
                      color: "#0f172a",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {departmentName}
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap:14,
                  flexShrink: 0,
                }}
              >
              <div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: 2,
    fontWeight: 700,
    fontSize: 11,
    color: ui.score,
  }}
>
  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
    <span
      style={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: ui.dot,
        display: "inline-block",
      }}
    />
    {fmtScore(row.Total_Average_Score)}
  </div>

  <div
    style={{
      fontSize: 9,
      fontWeight: 600,
      color: "#64748b",
    }}
  >
    CUM: {fmtScore(row.Department_Cumulative_Total_Average_Score)}
  </div>
</div>

                <button
                  onClick={() => loadDetails(departmentName)}
                  style={{
                    border: "none",
                    background: "#fff",
                    color: "#1f4e8c",
                    borderRadius: 5,
                    padding: "5px 0px",
                    fontWeight: 600,
                    fontSize: 11,
                    cursor: "pointer",
                   
                  }}
                >
                  {rowLoading ? "Loading..." : <LuEye size={16} />}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    })}
</div>



{!loading && !err && rows.length > 0 && (
  <div style={{ textAlign: "center", marginTop: 8 }}>
    <button
      onClick={() => {
        if (!showAll) {
          loadAllDepartments();
        } else {
          loadSummary();
        }
      }}
      style={{
        background: "transparent",
        border: "none",
        color: "#1f4e8c",
        fontWeight: 700,
        cursor: "pointer",
        fontSize: 13,
      }}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        {showAll ? "View Less" : "View More"}
        {showAll ? <IoIosArrowUp size={16} /> : <IoIosArrowDown size={16} />}
      </span>
    </button>
  </div>
)}


        </div>
      </div>

      {/* Modal */}
      {selectedDepartment && (
        <div
          onClick={() => setSelectedDepartment("")}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.45)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "96vw",
              maxWidth: 1500,
              maxHeight: "92vh",
              overflowY: "auto",
              background: "#ffffff",
              borderRadius: 16,
              boxShadow: "0 20px 60px rgba(0,0,0,0.22)",
              border: "1px solid #e2e8f0",
            }}
          >
            {/* Modal Header */}
            <div
              style={{
                position: "sticky",
                top: 0,
                zIndex: 2,
                background: "#fff",
                borderBottom: "1px solid #e5e7eb",
                padding: "14px 18px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 12,
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#0f172a",
                  }}
                >
                  {selectedDepartment}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "#64748b",
                    marginTop: 2,
                  }}
                >
                  {formatDisplayDate(startDate)} to {formatDisplayDate(endDate)}
                </div>
              </div>


              <button
  onClick={() => setShowPerformance((prev) => !prev)}
  style={{
    border: "1px solid #dbe3ef",
    background: showPerformance ? "#1f4e8c" : "#fff",
    color: showPerformance ? "#fff" : "#1f4e8c",
    borderRadius: 8,
    padding: "7px 12px",
    fontWeight: 700,
    cursor: "pointer",
  }}
>
  {showPerformance ? "Hide Performance" : "Show Performance"}
</button>

              <button
                onClick={() => setSelectedDepartment("")}
                style={{
                  border: "1px solid #dbe3ef",
                  background: "#fff",
                  color: "#1f4e8c",
                  borderRadius: 8,
                  padding: "7px 12px",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                Close ✕
              </button>
            </div>

            <div style={{ padding: 16 }}>
              {modalLoading && (
                <div
                  style={{
                    padding: 24,
                    textAlign: "center",
                    color: "#64748b",
                    fontWeight: 600,
                  }}
                >
                  Loading details...
                </div>
              )}

              {!modalLoading && modalDetails && (

                
                <>

                {showPerformance && (
  <div style={{ marginBottom: 20 }}>
    <div style={sectionTitleStyle}>Performance Trend</div>

    <ResponsiveContainer width="100%" height={300}>
      <LineChart
         margin={{ top: 10, right: 65, left: 30, bottom: 40 }}
        data={(modalDetails.Doer_Details || []).map((d) => ({
  name: `${d.Doer_Name} (Process: ${d.Source_Department})`,
  weekly: Number(d.Total_Average_Score || 0),
  cumulative: Number(d.Doer_Cumulative_Total_Average_Score || 0),
}))}
      >
        <CartesianGrid strokeDasharray="3 3" />
<XAxis
  dataKey="name"
  interval={0}
  height={80}
  padding={{ left: 40, right: 20 }}
  tick={(props) => {
    const { x, y, payload } = props;
    const lines = formatXAxisLabel(payload.value);

    return (
      <g transform={`translate(${x},${y})`}>
        {lines.map((line, index) => (
          <text
            key={index}
            x={0}
            y={index * 14}
            dy={16}
            textAnchor="middle"
            fill="#334155"
            fontSize={11}
          >
            {line}
          </text>
        ))}
      </g>
    );
  }}
/>
        <YAxis />
        <Tooltip />
        <Legend />

        <Line
          type="monotone"
          dataKey="weekly"
          stroke="#1f4e8c"
          strokeWidth={2}
          name="Weekly Score"
        />

        <Line
          type="monotone"
          dataKey="cumulative"
          stroke="#18a957"
          strokeWidth={2}
          name="Cumulative Score"
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
)}
                  {/* Department Summary */}
                  <div style={{ marginBottom: 18 }}>
                    <div style={sectionTitleStyle}>Department Summary</div>
                    <div style={tableWrapStyle}>
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          minWidth: 1000,
                        }}
                      >
                        <thead>
                          <tr>
                            {[
                              "Total Planned",
                              "Task Done",
                              "Task Not Done",
                              "Task Done On Time",
                              "Task Done Delay",
                              "Total Average Score",
                              "Below20Scoring",
                              "Department Cumulative Score",
                              "Department Cumulative Range",
                            ].map((h) => (
                              <th key={h} style={thStyle}>
                                {h}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={tdStyle}>{modalDetails.Total_Planned}</td>
                            <td style={tdStyle}>{modalDetails.Task_Done}</td>
                            <td style={tdStyle}>{modalDetails.Task_Not_Done}</td>
                            <td style={tdStyle}>{modalDetails.TaskDoneOnTime}</td>
                            <td style={tdStyle}>{modalDetails.TaskDoneNotOnTime}</td>
<td style={tdStyle}>
  <div style={getScoreStyle(modalDetails.Total_Average_Score)}>
    {fmtScore(modalDetails.Total_Average_Score)}
  </div>
</td>
                            <td style={tdStyle}>{modalDetails.Below20Scoring}</td>
                            <td style={{ ...tdStyle, fontWeight: 700 }}>
                              {fmtScore(
                                modalDetails.Department_Cumulative_Total_Average_Score
                              )}
                            </td>
<td style={tdStyle}>
  <div style={getRangeStyle()}>
    {modalDetails.Department_Cumulative_Date_Range}
  </div>
</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* HOD Details */}
                  {Array.isArray(modalDetails.HOD_Details) &&
                    modalDetails.HOD_Details.length > 0 && (
                      <div style={{ marginBottom: 18 }}>
                        <div style={sectionTitleStyle}>HOD Details</div>
                        <div style={tableWrapStyle}>
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              minWidth: 900,
                            }}
                          >
                            <thead>
                              <tr>
                                {[
                                  "HOD Name",
                                  "HOD Email",
                                  "HOD Location",
                                  "HOD Department",
                                ].map((h) => (
                                  <th key={h} style={thStyle}>
                                    {h}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {modalDetails.HOD_Details.map((hod, idx) => (
                                <tr key={`${hod.HOD_Email}-${idx}`}>
                                  <td style={tdStyle}>{hod.HOD_Name}</td>
                                  <td style={tdStyle}>{hod.HOD_Email}</td>
                                  <td style={tdStyle}>{hod.HOD_Location}</td>
                                  <td style={tdStyle}>{hod.HOD_Department}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                  {/* Doer Details */}
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 10,
                        gap: 12,
                        flexWrap: "wrap",
                      }}
                    >
                      <div style={sectionTitleStyle}>Doer Details</div>
                      <div
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: "#475569",
                        }}
                      >
                        Doer Count: {modalDetails.Doer_Count ?? 0}
                      </div>
                    </div>

                    <div style={tableWrapStyle}>
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          minWidth: 1500,
                        }}
                      >
                        <thead>
                          <tr>
                            {[
                              "Rank",
                              "Process",
                              "Doer Name",
                              "Location",
                              "Total Planned",
                              "Done",
                              "Not Done",
                              "On Time",
                              "Delay",
                              "Total Average Score",
                              "Doer Cumulative Score",
                              "Doer Cumulative Range",
                              "HOD Name",
                            ].map((h) => (
                              <th key={h} style={thStyle}>
                                {h}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {(modalDetails.Doer_Details || []).map((item, idx) => (
                            <tr key={`${item.Doer_Email}-${idx}`}>
                              <td style={tdStyle}>{item.Doer_Rank}</td>
                              <td style={tdStyle}>{item.Source_Department}</td>
                              <td style={{ ...tdStyle, fontWeight: 600 }}>
                                <div>{item.Doer_Name}</div>
                                <div
                                  style={{
                                    fontSize: 11,
                                    color: "#64748b",
                                    marginTop: 2,
                                  }}
                                >
                                  {item.Doer_Email}
                                </div>
                              </td>
                              <td style={tdStyle}>{item.Location}</td>
                              <td style={tdStyle}>{item.Total_Planned}</td>
                              <td style={tdStyle}>{item.Task_Done}</td>
                              <td style={tdStyle}>{item.Task_Not_Done}</td>
                              <td style={tdStyle}>{item.TaskDoneOnTime}</td>
                              <td style={tdStyle}>{item.TaskDoneNotOnTime}</td>
<td style={tdStyle}>
  <div style={getScoreStyle(item.Total_Average_Score)}>
    {fmtScore(item.Total_Average_Score)}
  </div>
</td>
                              <td style={tdStyle}>
                                {fmtScore(item.Doer_Cumulative_Total_Average_Score)}
                              </td>
<td style={tdStyle}>
  <div style={getRangeStyle()}>
    {item.Doer_Cumulative_Date_Range}
  </div>
</td>
                              <td style={tdStyle}>{item.HOD_Name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>


                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}